const receiptDateFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: "Asia/Ho_Chi_Minh",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

// Evaluate at submission time, independently of the form's initial date.
export const getReceiptDate = (now = new Date()) => {
  const parts = receiptDateFormatter.formatToParts(now);
  const value = (type) => parts.find((part) => part.type === type).value;
  return `${value("year")}-${value("month")}-${value("day")}`;
};
